import request from '@/utils/request'

export function selectInventoryHeader(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/layoutManagement/selectInventoryHeader?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function updateSubclassTypeV9(data) {
    return request({
        url: `api/serviceCenter/layoutManagement/updateSubclassTypeV9?`,
        method: 'post',
        data,
    })
}